import {mountRimLibrary} from './rim-library.mjs';
import {startAgentConnection} from './agent-connection.mjs';
import {mountAccountButton} from './account-button.mjs';
import catalog from './model-catalog.json' with {type: 'json'};
import {createModelRegistry} from './model-registry.mjs';
import {CapturedEditorAdapter} from './captured-editor-adapter.mjs';
import {mountModelLibrary} from './model-library.mjs';
import {createBridgeConnection} from './runtime-bridge.mjs';

// JSON is bundled: the library never waits on a catalog request during startup.
const registry = createModelRegistry(catalog);
let library;

function start() {
  if (library && !library.disposed) return;
  const adapter = new CapturedEditorAdapter(document);
  const connection = createBridgeConnection({window, adapter, registry});
  const rimLibrary = mountRimLibrary({window});
  const agents = startAgentConnection({window});
  const account = mountAccountButton({window});
  library = mountModelLibrary({
    adapter, registry, window,
    onReady: onChange => connection.connect(onChange),
    onDispose: () => { connection.dispose(); rimLibrary.dispose(); agents.dispose(); account.dispose(); }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start, {once: true});
} else {
  start();
}
// pagehide disposes observers/listeners; restore them when returning via bfcache.
window.addEventListener('pageshow', event => { if (event.persisted) start(); });
